import React from 'react';
import { Link } from 'react-router-dom';
import style from './NotFound.module.css';

const NotFound = () => {
  return (
    <div className={style.container}>
      <div className={style.wrapper404}>
        <div className={style.bubblesWrapper}>
          <span className={style.bubble + ' ' + style.bubble1} />
          <span className={style.bubble + ' ' + style.bubble2} />
          <span className={style.bubble + ' ' + style.bubble3} />
          <span className={style.bubble + ' ' + style.bubble4} />
          <span className={style.bubble + ' ' + style.bubble5} />
          <span className={style.bubble + ' ' + style.bubble6} />
          <span className={style.bubble + ' ' + style.bubble7} />
          <span className={style.bubble + ' ' + style.bubble8} />
        </div>
        <div className={style.oBlock}>Oops</div>
        <h1 className={style.heading404}>44</h1>
        <p className={style.text}>
          Looks like you may be trying to find a page that doesn't exist or has been moved.
          <br />
          Start from the <Link to='/'>Home</Link> again.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
